<template>
  <div class="spinner">
    <div class="container">
      <h1>At Your Service</h1>
      <img src="/styles/loading.svg" alt="loading" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Loading",
  props: {
    msg: String
  },
  computed: {},
  created() {
    this.$store.dispatch("entities/settings/setIsOffline", false);
  },
  updated() {},
  methods: {}
};
</script>

<style scoped lang="stylus">
// /*div.spinner h1{
//   text-align: center;
//   margin-bottom: 2rem;
//   font-size: 1.25rem;
// }
// div.spinner .container {
//   height: 6rem;
//   text-align: center;
//   color: #555;
// }
// div.spinner {
//   position: absolute;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   height: 100vh;
//   width: 100vw;
//   background-color: white;
//   top: 0;
//   bottom: 0;
//   left: 0;
//   right: 0;
// }*/
</style>
